module.exports = __webpack_public_path__ + "static/media/ps.dba57098.svg";